<template>
  <div class="simple-filter-or-block">
    <div class="block">

      <div class="arg" v-for="(arg, argId) in expression.args">
        <div class="orLine" v-if="argId > 0">OR</div>
        <FilterExpression :expression="arg" @update:expression="setArg(argId, $event)" :columns="columns"
                           :parent="definition" @delete="deleteArg(argId)"></FilterExpression>
        <button class="mdl-button add-button" v-if="definition.isList" v-on:click="addArg">
          <i class="material-icons">add</i> OR
        </button>
        <button class="mdl-button add-button" v-if="definition.isList && argId+1 == expression.args.length" v-on:click="addOuterAnd">
          <i class="material-icons">add</i> AND
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import expression from "../../logic/expression.js"
import FilterExpression from "./FilterExpression"

export default {
  name: 'simple-filter-or-block',
  props: {
    columns: {
      type: Array,
      default: function () {
        return []
      }
    },
    expression: {
      type: Object,
      default: function() {
        return {
          type: "and",
          args: []
        }
      }
    },
    parent: {
      type: Object,
      default: function() {
        return null
      }
    }
  },
  components: {
    FilterExpression
  },
  data () {
    return {
    }
  },
  computed: {
    definition() {
      return expression.operatorsByName.get(this.expression.type)
    }
  },
  watch: {
  },
  methods: {
    operatorTitle(name) {
      for (let op of this.possibleOperators) {
        if (op.name == name) return op.title
      }
    },
    operatorDefinition(expr) {
      const operator = expression.operatorsByName.get(expr.type)
      console.log("OP", operator)
      return operator
    },
    addArg() {
      var narg = expression.newArg(this.expression, this.columns)
      this.$emit('update:expression', {
        type: this.expression.type,
        args: this.expression.args.concat([narg])
      })
    },
    setArg(argId, ev) {
      console.log("SET ARG", argId, ev)
      const nArgs = this.expression.args.slice()
      nArgs[argId] = ev
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      })
    },
    deleteArg(argId) {
      if (this.expression.args.length <= 1) {
        return this.deleteThis()
      }
      console.log("DELETE ARG", argId)
      const nArgs = this.expression.args.slice()
      nArgs.splice(argId, 1)
      this.$emit('update:expression', {
        type: this.expression.type,
        args: nArgs
      })
    },
    setType(ev) {
      let nType = ev.target.value
      var nDefinition = expression.operatorsByName.get(nType)
      console.log("SET TYPE", nType)
      if (!this.definition.isLogical && nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [JSON.parse(JSON.stringify(this.expression))]
        })
      } else if (this.definition.isLogical && !nDefinition.isLogical) {
        this.$emit('update:expression', {
          type: nType,
          args: [nDefinition.defaultArgs(this.columns)]
        })
      }
      /* else if ((this.definition.element != nDefinition.element)
        || (this.definition.left != nDefinition.left)
        || (this.definition.right != nDefinition.right)) {
        console.log("RESET ARGS")
        this.$emit('update:expression', {
          type: nType,
          args: nDefinition.defaultArgs(this.columns)
        })
      }*/ else {
        console.log("HOLD ARGS")
        this.$emit('update:expression', {
          type: nType,
          args: this.expression.args
        })
      }
    },
    deleteThis() {
      this.$emit('delete')
    },
    addOuterAnd() {
      this.$emit(
        'addAnd')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .block > button {
    display: block;
    font-size: 0.77em;
    height: 2em;
    line-height: 2em
  }

  .block > button i {
    font-size: 1.23em;
    line-height: 0.77em;
  }
  .block > .delete-button {
    display: inline-block;
    font-size: 0.77em;
    line-height: 1em;
    position: relative;
    top: -2px;
    float: right;
  }

  .block > .arg > button {
    display: inline-block;
    font-size: 0.77em;
    height: 2em;
    line-height: 2em
  }

  .block > .arg > button i {
    font-size: 1.23em;
    line-height: 0.77em;
  }

  .orLine {
    font-size: 0.8em;
    position: relative;
    margin-left: 1em;
    font-weight: 700;
  }

</style>



// WEBPACK FOOTER //
// SimpleFilterOrBlock.vue?0668e220